// loading event type defines what sort of loading action should be handled.
// if set to page, the page should be hidden/inactive until the loading event is 
// complete. If set to form, the form cannot be submitted, but other elements on the
// page can be interacted with
enum LoadingEventType {
		Page = 1,
		Form = 2
}

export { LoadingEventType };